import { useEffect } from 'react';
import config from '../config';
import { getFlag } from './flags';
import { AppToaster } from '../shared/toaster';

let lastWarmTime = 0;

export default function useCloudFunctionWarmer() {
  useEffect(() => {
    const alreadyWarm = Date.now() - lastWarmTime < 60000;
    if (!getFlag('localApi') && !alreadyWarm) {
      const url = `${process.env.NODE_ENV === 'development' ? config.apiBase : ''}/api/warmup`;
      fetch(url)
        .then((res) => {
          if (res.status >= 500) {
            AppToaster.show({
              message:
                'Platform outage: One of our Cloud providers is currently unavailable. Some features may not work until service is restored.',
              intent: 'danger',
              icon: 'cloud',
              timeout: 0, // persistent
              isCloseButtonShown: true,
            });
          }
        })
        .catch(() => {
          // Network error, could also show a toast if desired
        });
      lastWarmTime = Date.now();
    }
  }, []);
}
